<template>
  <div style="margin-left: 150px;margin-top: 20px;width:60%;box-shadow: 0 0 5px #ccc;padding: 20px 0">
    <el-form label-width="120px" ref="post" :model="post" >
      <el-form-item label="用户姓名" prop="name">
        <el-input placeholder="用户姓名" disabled v-model="post.name" class="w-200"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="phone">
        <el-input placeholder="手机号码" disabled v-model="post.phone" class="w-200"></el-input>
      </el-form-item>
      <el-form-item label="地址信息" >
        <el-input placeholder="地址信息" disabled v-model="post.city" class="w-200"></el-input>
      </el-form-item>
      <el-form-item label="绑定微信用户" prop="user">
        <el-input placeholder="绑定微信用户" disabled v-model="post.user.nickname" class="w-200"></el-input>
      </el-form-item>
      <el-form-item label="提交时间">
        <el-input placeholder="提交时间" disabled v-model="post.addtime" class="w-200"></el-input>
      </el-form-item>
      <el-form-item label="审核状态">
        <el-input placeholder="审核状态" disabled v-model="post.is_pass" class="w-200"></el-input>
      </el-form-item>
      <el-form-item label="审核时间">
        <el-input placeholder="审核时间" disabled v-model="post.check_time" class="w-200"></el-input>
      </el-form-item>
      <el-form-item label="可分配次数" >
        <el-input placeholder="可分配次数" disabled v-model="post.use_num" class="w-200"></el-input>
      </el-form-item>
<!--      <el-form-item>-->
<!--        <el-button type="primary" @click="submit">确定提交</el-button>-->
<!--      </el-form-item>-->
    </el-form>
  </div>
</template>

<script>
export default {
name: "mine",
  data(){
    return{
      post: {}
    }
  },
  mounted: async function(){
    try {
      await this.get_one();
    }catch (e) {
      console.log(e);
    }
  },
  methods:{
    get_one:async function (){
      let res = await this.$_api.company('get_one_for_post', {uid : this.user.uid});
      if (res.errcode == 0){
        this.post = res.post;
      }
    }
  }
}
</script>

<style scoped>
.el-input{
  width: 250px;
}
</style>